import Vue from "vue";
import Router from "vue-router";
import Top from "./components/pages/TopPage.vue";
import Fukugyo from "./components/pages/FukugyoPage.vue";
import Error404 from "./components/pages/error/404";
import UnsubscribePage from "./components/pages/user/UnsubscribePage";
import ClientTopPage from "./components/pages/clients/ClientTopPage";
import ClientProfilePage from "./components/pages/clients/ClientProfilePage";
import CompanyProfile from "./components/organisms/CompanyProfile";
import PersonProfile from "./components/organisms/PersonProfile";
import UnsubscribeCompletedPage from "./components/pages/user/UnsubscribeCompletedPage";
import ClientJobTopPage from "./components/pages/clients/job/ClientJobTopPage";
import ClientJobNewPage from "./components/pages/clients/job/ClientJobNewPage";
import ClientJobEditPage from "./components/pages/clients/job/ClientJobEditPage";
import ClientJobDetailPage from "./components/pages/clients/job/ClientJobDetailPage";
import ClientCandidateTopPage from "./components/pages/clients/candidate/ClientCandidateTopPage";
import JobPage from "./components/pages/job/JobPage";
import JobCandidatePage from "./components/pages/job/JobCandidatePage";
import JobCandidateCompletePage from "./components/pages/job/JobCandidateCompletePage";
import JobCasualMeetingPage from "./components/pages/job/JobCasualMeetingPage";
import JobCasualMeetingCompletePage from "./components/pages/job/JobCasualMeetingCompletePage";
import ClientServiceTermsPage from "./components/pages/clients/ClientServiceTermsPage";
import EmailVerification from "@/components/pages/user/EmailVerification";
import ClientImagesPage from "@/components/pages/clients/ClientImagesPage";
import ClientRegisterCompletedPage from "@/components/pages/clients/ClientRegisterCompletedPage";
import ClientMessagesPage from "@/components/pages/message/ClientMessagesPage";
import CandidateMessagesPage from "@/components/pages/message/CandidateMessagesPage";
import ChatRequestPage from "@/components/pages/clients/ChatRequestPage";
import ChatRequestJobSettingPage from "@/components/pages/clients/ChatRequestJobSettingPage";
import RedirectPage from "./components/pages/RedirectPage";
import ClientsRedirectPage from "./components/pages/clients/ClientsRedirectPage";
import ClientLoginPage from "./components/pages/clients/ClientLoginPage";
import JobSearchPage from "./components/pages/JobSearchPage";
import Requestors from "./components/organisms/Requestors";
import ScoutMessageTemplates from "./components/organisms/ScoutMessageTemplates.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "top",
      component: Top,
    },
    {
      path: "/fukugyo",
      name: "fukugyo",
      component: Fukugyo,
    },
    {
      path: "/search",
      name: "JobSearch",
      component: JobSearchPage,
    },
    {
      path: "/clients",
      name: "clients",
      component: ClientTopPage,
    },
    {
      path: "/clients/company",
      component: ClientProfilePage,
      meta: {
        requiredLogin: true,
      },
      children: [
        {
          path: "",
          name: "CompanyProfile",
          component: CompanyProfile,
          meta: {
            requiredLogin: true,
          },
        },
        {
          path: "person",
          name: "PersonProfile",
          component: PersonProfile,
          meta: {
            requiredLogin: true,
          },
        },
        {
          path: "requestors",
          name: "Requestors",
          component: Requestors,
          meta: {
            requiredLogin: true,
          },
        },
        {
          path: "scout-templates",
          name: "ScoutTemplates",
          component: ScoutMessageTemplates,
          meta: {
            requiredLogin: true,
          },
        },
      ],
    },
    {
      path: "/clients/jobs",
      name: "ClientJobTop",
      component: ClientJobTopPage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/clients/jobs/new",
      name: "ClientsJobNew",
      component: ClientJobNewPage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/clients/jobs/:id",
      name: "ClientJobDetail",
      component: ClientJobDetailPage,
      meta: {
        requiredLogin: true,
        isClient: true
      },
    },
    {
      path: "/clients/jobs/:id/draft",
      name: "ClientJobDetailDraft",
      component: ClientJobDetailPage,
      meta: {
        requiredLogin: true,
        isClient: true,
        draft: true
      },
    },
    {
      path: "/clients/jobs/:id/edit",
      name: "ClientsJobEdit",
      component: ClientJobEditPage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/clients/images",
      name: "ClientImages",
      component: ClientImagesPage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/clients/candidates",
      name: "ClientCandidateTop",
      component: ClientCandidateTopPage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/clients/messages/:id?",
      name: "ClientMessages",
      component: ClientMessagesPage,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: "/clients/terms",
      name: "ClientTerms",
      component: ClientServiceTermsPage,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: "/clients/unsubscribe",
      name: "clientUnsubscribe",
      component: UnsubscribePage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/clients/unsubscribe-completed",
      name: "clientUnsubscribeCompleted",
      component: UnsubscribeCompletedPage,
    },
    {
      path: "/clients/chat-requests",
      name: "RequestsPageJobSettingPage",
      component: ChatRequestJobSettingPage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/clients/chat-requests/:id",
      name: "RequestsPage",
      component: ChatRequestPage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/clients/thanks",
      name: "ClientRegisterCompletedPage",
      component: ClientRegisterCompletedPage,
    },
    {
      path: "/clients/redirect",
      name: "ClientsRedirect",
      component: ClientsRedirectPage,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: "/clients/login",
      name: "ClientsLogin",
      component: ClientLoginPage,
    },
    {
      path: "/unsubscribe",
      name: "unsubscribe",
      component: UnsubscribePage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/unsubscribe-completed",
      name: "unsubscribeCompleted",
      component: UnsubscribeCompletedPage,
    },
    {
      path: "/jobs/:id",
      name: "job",
      component: JobPage,
      meta: {
        requiredLogin: false,
      },
    },
    {
      path: "/jobs/:id/candidates",
      name: "jobCandidate",
      component: JobCandidatePage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/jobs/:id/candidates/complete",
      name: "jobCandidateComplete",
      component: JobCandidateCompletePage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/jobs/:id/casual_meetings",
      name: "jobCasualMeeting",
      component: JobCasualMeetingPage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/jobs/:id/casual_meetings/complete",
      name: "jobCasualMeetingComplete",
      component: JobCasualMeetingCompletePage,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/messages/:id?",
      name: "CandidateMessages",
      component: CandidateMessagesPage,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: "/email_verification",
      name: "EmailVerification",
      component: EmailVerification,
      meta: {
        requiredLogin: true,
      },
    },
    {
      path: "/redirect",
      name: "Redirect",
      component: RedirectPage,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: "*",
      component: Error404,
    },
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    }
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
    if (to.meta && from.meta && to.meta.tabItem && from.meta.tabItem) {
      return null;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (process.env.VUE_APP_SERVICE) {
    if (process.env.VUE_APP_SERVICE === 'client' && !to.path.startsWith('/client')) {
      window.location = `${process.env.VUE_APP_NISHIKA_CONNECT_URL}${to.path}`;
      return;
    }
    if (process.env.VUE_APP_SERVICE !== 'client' && to.path.startsWith('/client')) {
      window.location = `${process.env.VUE_APP_NISHIKA_CONNECT_CLIENT_URL}${to.path}`;
      return;
    }
  }
  next();
});

export default router;
